export default __webpack_public_path__ + "static/media/DesktopPeople.2f189db0.png";